import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconInboxEmpty: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"inbox-empty"} maskId="square-filled-radius-0-stroke-1-IconInboxEmpty"><path fillRule="evenodd" clipRule="evenodd" d="M5.40694 4H18.5931L23 11.8695V20H1V11.8695L5.40694 4ZM2 19H22V13H15.75L14.25 15H9.75L8.25 13H2V19Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconInboxEmpty;
